import { Card, Col, Row, Table } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import { apiService } from "service/ApiService";
import { getModeNameByid } from "utils/AppUtils";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function PaymentMethodSalesTable() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [totalSales, setTotalSales] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalTips, setTotalTips] = useState(0);
  const [totalTipsCount, setTotalTipsCount] = useState(0);
  const [tipsData, setTipsData] = useState([]);
  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/payment-method-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        formatData(resp);
        setData(resp.paymentMethods);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (data) => {
    let totalSales = 0;
    let totalCount = 0;
    let totalTips = 0;
    let totalTipsCount = 0;

    data.paymentMethods.map((el) => {
      totalSales += el.total;
      totalCount += Number(el.count);
    });

    data.tips.map((el) => {
      totalTips += el.total ? el.total : 0;
      totalTipsCount += Number(el.count);
    });

    setTotalSales(totalSales.toFixed(2));
    setTotalCount(totalCount);
    setTotalTips(totalTips.toFixed(2));
    setTotalTipsCount(totalTipsCount);
    setTipsData(data.tips.filter((el) => el.count > 0));
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Card className="strpied-tabled-with-hover">
        <Card.Header>
          <Row>
            <Col>
              <Card.Title as="h4">{t("reports.salesByPaymentMethod")}</Card.Title>
              <p className="card-category">{t("common.labels.excludesOpenOrdersAndSpecialItems")}</p>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="table-responsive p-0">
          {showLoader ? (
            <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
              <ClipLoader size={50} color={"#ff6fbc"} />
            </div>
          ) : (
            <Table className="table-hover align-text-right" style={{ tableLayout: "fixed" }}>
              <tbody>
                {data.map((row) => (
                  <tr key={row.payment_method_id}>
                    <td className="bold align-text-left" style={{ color: row.payment_method_color }}>
                      {row.payment_method_name}
                    </td>
                    <td>{row.count}</td>
                    <td>{row.total.toFixed(2)}</td>
                    <td>{((100 * row.total) / totalSales).toFixed(2)}%</td>
                  </tr>
                ))}
                <tr key="total">
                  <td className="bold align-text-left">{t("tables.headers.total")}</td>
                  <td className="bold">{totalCount}</td>
                  <td className="bold">{totalSales}</td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {!showLoader && totalTips > 0 ? (
        <Card className="strpied-tabled-with-hover">
          <Card.Header>
            <Row>
              <Col>
                <Card.Title as="h4">Tips</Card.Title>
                <p className="card-category">{t("common.labels.tipAnalysisByMode")}</p>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="table-responsive p-0">
            <Table className="table-hover align-text-right" style={{ tableLayout: "fixed" }}>
              <tbody>
                {tipsData.map((row) => (
                  <tr key={`tips-mode-${row.mode}`}>
                    <td className="bold align-text-left">{getModeNameByid(row.mode)}</td>
                    <td>{row.count}</td>
                    <td>{row.total ? row.total.toFixed(2) : 0}</td>
                    <td>{((100 * row.total) / totalTips).toFixed(2)}%</td>
                  </tr>
                ))}
                <tr key="total">
                  <td className="bold align-text-left">{t("tables.headers.total")}</td>
                  <td className="bold">{totalTipsCount}</td>
                  <td className="bold">{totalTips}</td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </>
  );
}

export default PaymentMethodSalesTable;
